import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../@commons/ui-components/shared.module';
import RoutesConstants from '../../@commons/constants/routes.constants';
import { isSeasonPlanBannerPeriod } from '../season-plan.util';

/**
 * Entrée de « Mon plan de saison » (NF-1, K21) : un bandeau dans Mon potager et dans Mes
 * graines, du 8 février au 31 mars, jamais sur l'accueil. Hors de cette fenêtre, rien.
 */
@Component({
  selector: 'vw-season-plan-banner',
  imports: [SharedModule, TranslatePipe],
  templateUrl: './season-plan-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SeasonPlanBannerComponent {
  /** Date du jour, injectable pour les tests. */
  @Input() today: Date = new Date();

  constructor(private router: Router) {}

  get visible(): boolean {
    return isSeasonPlanBannerPeriod(this.today);
  }

  open(): void {
    this.router.navigate([RoutesConstants.SEASON_PLAN]);
  }
}
